export enum DmsDocType {
  BillOfLading = 'Bill of Lading',
  DeliveryReceipt = 'Delivery Receipt',
  LetterOfAuthorization = 'Letter of Authorization',
  InvoicePdf = 'Invoice PDF',
  WeightInspectionCertificate = 'Weight Certificate',
  NmfcClassInspectionCertificate = 'Inspection Certificate',
  Customs = 'Customs'
}
